module.exports = __webpack_public_path__ + "img/23.d30b55cd.png";